import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
export default {
  methods: {
    onChangeLocale: function onChangeLocale(command) {
      console.log('command--', command);
      this.$i18n.locale = command;
      var message = "".concat(this.$t('localePage._1')).concat(this.$t('_name'), " [ ").concat(this.$i18n.locale, " ]");

      if (process.env.VUE_APP_BUILD_MODE === 'PREVIEW') {
        message = ["".concat(this.$t('localePage._1')).concat(this.$t('_name'), " [ ").concat(this.$i18n.locale, " ]")].join('<br/>');
      }

      this.$notify({
        title: this.$t('localePage._2'),
        dangerouslyUseHTMLString: true,
        message: message
      });
    }
  }
};